/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./ChatDismissModal.vue?vue&type=template&id=1e6122d2"
import script from "./ChatDismissModal.vue?vue&type=script&lang=js"
export * from "./ChatDismissModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e6122d2')) {
      api.createRecord('1e6122d2', component.options)
    } else {
      api.reload('1e6122d2', component.options)
    }
    module.hot.accept("./ChatDismissModal.vue?vue&type=template&id=1e6122d2", function () {
      api.rerender('1e6122d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/chat/ChatDismissModal.vue"
export default component.exports